import Heading from './Heading.vue'

export default Heading
